// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const { USER_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/user/actions')
const ImageUrlSizes = require('client-v2/common/records/image-url-sizes')
const { keyedReviver } = require('client-v2/common/state/record-reviver')

// Basically just `client-v2/common/models/user/record` with more fields

class ProfileUserRecord extends Immutable.Record({
  bio: null,
  'custom_url': String(),
  'display_name': String(),
  'header_image_urls': null,
  id: null,
  isFollowing: Boolean(),
  mixesBio: null,
  'photo_url': String(),
  type: String(modelTypes.USER),
  username: String()
}) {
  // No methods
}

ProfileUserRecord.reviver = keyedReviver(ProfileUserRecord, {
  'header_image_urls': ImageUrlSizes.reviver
})

ProfileUserRecord.propTypes = {
  bio: PropTypes.string,
  'custom_url': PropTypes.string,
  'display_name': PropTypes.string.isRequired,
  'header_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
  id: PropTypes.number.isRequired,
  isFollowing: PropTypes.oneOf([true, false, USER_FOLLOWING_CHANGE_PENDING]),
  mixesBio: PropTypes.string,
  'photo_url': PropTypes.string,
  username: PropTypes.string.isRequired
}

module.exports = ProfileUserRecord
